export default __webpack_public_path__ + "static/media/dashboard.d9585c08.svg";